import { useContext } from "react";
import { GlobalContext } from "../../../context";

/** Students get the new LMS page; admins and instructors keep the page they had. */
export default function StudentPageSwitch({ student, staff }) {
  const { authState: { data } } = useContext(GlobalContext);
  const isStaff = data?.user?.is_admin || data?.user?.is_instructor;
  return isStaff ? staff : student;
}
